import { render, staticRenderFns } from "./Action.vue?vue&type=template&id=6b6426a8&scoped=true"
import script from "./Action.vue?vue&type=script&setup=true&lang=ts"
export * from "./Action.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./Action.vue?vue&type=style&index=0&id=6b6426a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b6426a8",
  null
  
)

export default component.exports